import { useCallback, useState } from 'react';

export const useLocalStorage = <T>(
  key: string,
  initialValue: T,
): [T, (value: T | ((prevValue: T) => T)) => void] => {
  const [storedValue, setStoredValue] = useState<T>(() => {
    try {
      const item = localStorage.getItem(key);
      return item !== null ? (JSON.parse(item) as T) : initialValue;
    } catch {
      return initialValue;
    }
  });

  const setValue = useCallback(
    (value: T | ((prevValue: T) => T)) => {
      setStoredValue((prevValue) => {
        const nextValue =
          typeof value === 'function' ? (value as (prevValue: T) => T)(prevValue) : value;
        try {
          localStorage.setItem(key, JSON.stringify(nextValue));
        } catch {
          // ignore
        }
        return nextValue;
      });
    },
    [key],
  );

  return [storedValue, setValue];
};
